import React from 'react';
import * as $ from 'jquery';
import useHttp from '../../../../../hook/use-http';
import { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { INIT_STATE_SELECTS, INDEX } from "../../../../../constants/driveglobalfilterinitalstates_bus";
import CustomSelect_Bus from './CustomSelect_Bus';
import { BsFillSkipBackwardBtnFill } from "react-icons/bs";
import { API_URL_MAIN } from '../../../../../constants/driveglobalfilterinitalstates_bus';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCityDepo } from '../../../../../redux/cityDepoSlice';
// import "./BDT_Filter_Bus.css"
// import { FaBackward } from 'react-icons/fa';
// import styles from './BDT_Bus.module.css'
import styles from './Filter_Bus.module.css'
// import filterStyles from './BDT_Filter_Bus.module.css'
// import "./BDT_Filter_Bus.css"
import "./styles.css"
 
 
export default function BDT_Filter(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  // const [changedColumn, setChangedColumn] = useState("");
  // const [columnfilters, setcolumnfilters] = useState([]);
  // const [routeOptions, setRouteOptions] = useState([]);
  // const [selectedRoute, setSelectedRoute] = useState([]);
  // const [selectedDepo, setSelectedDepo] = useState([]);
  // // const [singleBtn, setsingleBtn] = useState(false);
  // const [lastChangedField, setLastChangedField] = useState("");

 
  // useEffect(() => {
  //   // Reset depo and route when city changes
  //   if (filterdata.CITY) {
  //     setSelectedDepo([]);
  //     setSelectedRoute([]);
  //     setFilterData(prev => ({ ...prev, DEPO: [], ROUTE: [] }));
  //     props.onsubmit(prev => ({ ...prev, DEPO: [], ROUTE: [] }));
  //   }
  // }, [filterdata.CITY]);

  // useEffect(() => {
  //   // Reset route when depo changes
  //   if (filterdata.DEPO) {
  //     setSelectedRoute([]);
  //     setFilterData(prev => ({ ...prev, ROUTE: [] }));
  //     props.onsubmit(prev => ({ ...prev, ROUTE: [] }));
  //   }
  // }, [filterdata.DEPO]);
 
  const inputRef = useRef(null);
 
  // const updateFilter = (arr, index) => {
  //   console.log(arr,index)
  //   let state_ind = INDEX[index];
  //   setFilterData((prev) => { return { ...filterdata, [state_ind]: arr } })
  //   props.onsubmit((prev) => { return { ...filterdata, [state_ind]: arr } });
 
  //   setChangedColumn(index);
  //   if (columnfilters.indexOf(index) == -1) {
  //     setcolumnfilters([...columnfilters, index]);
  //   }
  // }
 
 
  const formatDateForDisplay = (date) => {
    return date ? moment(date).format('MMM D, YYYY') : '';
  };
 
  useEffect(() => {
    if (filterdata.startDate) {
      const today = moment();
      const fiveYearsAgo = moment().subtract(5, 'years');
      const defaultStart = moment(filterdata.startDate);
      const defaultEnd = moment(filterdata.endDate);
 
      $(inputRef.current).daterangepicker(
        {
          startDate: defaultStart,
          endDate: defaultEnd,
          minDate: fiveYearsAgo,
          maxDate: today,
          showDropdowns: true,
          autoUpdateInput: false, // Disable auto input update
          singleMonthMode: true,
          linkedCalendars: false,
          locale: {
            format: 'MMMM D, YYYY',
            applyLabel: 'Apply',
            separator: ' - ',
            cancelLabel: '',
          },
        }
      );
 
      // Handle 'Apply' button click
      $(inputRef.current).on('apply.daterangepicker', function (ev, picker) {
        const start = picker.startDate.format("YYYY-MM-DD");
        const end = picker.endDate.format("YYYY-MM-DD");
 
        $(this).val(
          picker.startDate.format('MMMM D, YYYY') + ' - ' + picker.endDate.format('MMMM D, YYYY')
        );
 
        setFilterData(prev => ({
          ...prev,
          startDate: start,
          endDate: end,
        }));
        props.onsubmit(prev => ({
          ...prev,
          startDate: start,
          endDate: end,
        }));
      });
 
      // Optional: clear input on cancel
      $(inputRef.current).on('cancel.daterangepicker', function () {
        $(this).val('');
        setFilterData(prev => ({
          ...prev,
          startDate: null,
          endDate: null,
        }));
      });
    }
 
    return () => {
      if ($(inputRef.current).data('daterangepicker')) {
        $(inputRef.current).data('daterangepicker').remove();
        $(inputRef.current).off('.daterangepicker');
      }
    };
  }, []);
 
  return (
    <>
      <div className="card mb-3 p-3">
        <div className="row">
 
          {/* Wider Date Range */}
          <div className="col-md-3">
            <div className={`mb-1 ${styles.date_range_selection}`}>Date Range</div>
            <div className="input-group mt-1">
              <input
                type="text"
                ref={inputRef}
                className={`form-control ${styles.customDateRangePicker}`}
                placeholder="Select date range"
                value={
                  filterdata.startDate && filterdata.endDate
                    ? `${formatDateForDisplay(filterdata.startDate)} - ${formatDateForDisplay(filterdata.endDate)}`
                    : ''
                }
                readOnly
              />
            </div>
          </div>
 
          {/* Other inputs */}
          <div className="col-md-9">
            <CustomSelect_Bus setGlobalFilter={props.setGlobalFilter} ></CustomSelect_Bus>
          </div>
        </div>
      </div>
    </>
  )
}
 
 
 
 
 
 
 
 
 
// import React from 'react';
// import * as $ from 'jquery';
// import useHttp from '../../../../hook/use-http';
// import { useState, useRef, useEffect } from 'react';
// import moment from 'moment';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { INIT_STATE_SELECTS, INDEX } from "../../../../constants/driveglobalfilterinitalstates_bus";
// import CustomSelect_Bus from './CustomSelect_Bus';
// import { BsFillSkipBackwardBtnFill } from "react-icons/bs";
// import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { selectCityDepo } from '../../../../redux/cityDepoSlice';
// // import "./BDT_Filter_Bus.css"
// // import { FaBackward } from 'react-icons/fa';
// // import styles from './BDT_Bus.module.css'
// import styles from './BDT_Filter_Bus.module.css'
// // import filterStyles from './BDT_Filter_Bus.module.css'
// // import "./BDT_Filter_Bus.css"
// import "./styles.css"
 
 
// export default function BDT_Filter(props) {
//   const { isLoading, error, sendReq: fetchData } = useHttp();
//   const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
//   const [changedColumn, setChangedColumn] = useState("");
//   const [columnfilters, setcolumnfilters] = useState([]);
//   const [singleBtn, setsingleBtn] = useState(false);
 
//   useEffect(() => {
//     setFilterData({ ...props.gloablfilter })
//   }, [props.gloablfilter])
//   // code to get city_depo from redux
//   // const [userCityDepo, setUserCityDepo] = useState({})
//   // const cityDepoAccess = useSelector(selectCityDepo);
//   // code to get city_depo from redux
 
//   // const inputElement = useRef();
//   // const filterHideShow = () => {
//   //   $("#filterSearch").toggle("slow");
//   // }
 
//   // const [refreshDate, setRefreshDate] = useState("")
//   // useEffect(() => {
//   //   fetchData({ url: API_URL_MAIN + "battery_digital_twin/BDT_refreshdate", body: {} }, refreshDateData)
//   //   if (props.gloablfilter?.DEPO.length > 0) {
//   //     setcolumnfilters([...columnfilters, "DEPO_INDEX"])
//   //   }
//   //   setUserCityDepo(cityDepoAccess)
//   // }, [])
 
//   // useEffect(() => {
//   //   if (props.gloablfilter?.VIN_NUM.length === 1) {
//   //     // setToHIdeShowRCA("d-inline-block")
//   //     setToSendChasisRCA(props.fromTableToFilter_vin)
//   //   }
//   // }, [props])
 
//   // const refreshDateData = (data) => {
//   //   setRefreshDate(data.value_as_string);
//   // }
 
//   const updateFilter = (arr, index) => {
//     let state_ind = INDEX[index];
//     setFilterData((prestate) => { return { ...filterdata, [state_ind]: arr } })
//     setChangedColumn(index);
//     if (columnfilters.indexOf(index) == -1) {
//       setcolumnfilters([...columnfilters, index]);
//     }
//   }
 
//   // const vinnumChanged = (e) => {
//   //   let enterter_vin = e.target.value;
//   //   if (enterter_vin != "") {
//   //     let new_vin = enterter_vin.split(",");
//   //     if (new_vin.length == 1) {
//   //       setsingleBtn(true);
//   //     }
//   //     setChangedColumn("VIN_NUM");
//   //     let VIN_NUM = "VIN_NUM";
//   //     setFilterData((prestate) => { return { ...filterdata, VIN_NUM: new_vin } })
//   //     if (columnfilters.indexOf("VIN_NUM") == -1) {
//   //       setcolumnfilters([...columnfilters, "VIN_NUM"]);
//   //     }
//   //   }
//   // }
 
//   // const startDateChanged = (date) => {
//   //   let sDate = "startDate";
//   //   setChangedColumn("startDate");
//   //   setFilterData((prestate) => { return { ...filterdata, [sDate]: date } })
//   //   if (columnfilters.indexOf("START_DATE") == -1) {
//   //     setcolumnfilters([...columnfilters, "START_DATE"]);
//   //   }
//   // }
 
//   // const endDateChanged = (date) => {
//   //   let eDate = "endDate";
//   //   setChangedColumn("endDate");
//   //   setFilterData((prestate) => { return { ...filterdata, [eDate]: date } })
//   //   if (columnfilters.indexOf("END_DATE") == -1) {
//   //     setcolumnfilters([...columnfilters, "END_DATE"]);
//   //   }
//   // }
 
//   // const [toHIdeShowRCA, setToHIdeShowRCA] = useState("d-none")
//   const [toSendChasisRCA, setToSendChasisRCA] = useState(0)
//   // const [depoErrMsg, setDepoErrMsg] = useState("")
 
// const onsubmit = (e) => {
//   setDepoErrMsg("")
//   e.preventDefault();
//   if (userCityDepo.depot.length === 0) {
//     if (filterdata?.VIN_NUM.length === 1) {
//       // setToHIdeShowRCA("d-inline-block")
//       // setToSendChasisRCA(filterdata?.VIN_NUM[0])
//     }
//     props.onsubmit(filterdata);
//   } else {
//     if (filterdata?.DEPO.length === 0) {
//       setDepoErrMsg("Please select at least 1 depot")
//     } else {
//       if (filterdata?.VIN_NUM.length === 1) {
//         // setToHIdeShowRCA("d-inline-block")
//         // setToSendChasisRCA(filterdata?.VIN_NUM[0])
//       }
//       props.onsubmit(filterdata);
//     }
//   }
// }
// const onreset = (e) => {
//   window.location.reload(true);
// }
 
 
//   //----
 
//   // const [globalFilters, setGlobalFilters] = useState({ ...props.globalFilters });
//   const inputRef = useRef(null);
 
 
//   // Function to format the date for display (in "MMMM D, YYYY" format)
 
//   const formatDateForDisplay = (date) => {
//     return date ? moment(date).format('MMMM D, YYYY') : '';
//   };
 
//   useEffect(() => {
//     if (filterdata.startDate) {
//       const today = moment();
//       const fiveYearsAgo = moment().subtract(5, 'years');
//       const defaultStart = moment(filterdata.startDate);
//       const defaultEnd = moment(filterdata.endDate);
 
//       $(inputRef.current).daterangepicker(
//         {
//           startDate: defaultStart,
//           endDate: defaultEnd,
//           minDate: fiveYearsAgo,
//           maxDate: today,
//           showDropdowns: true,
//           autoUpdateInput: false, // Disable auto input update
//           singleMonthMode: true,
//           linkedCalendars: false,
//           locale: {
//             format: 'MMMM D, YYYY',
//             applyLabel: 'Apply',
//             separator: ' - ',
//             cancelLabel: '',
//           },
//         }
//       );
 
//       // Handle 'Apply' button click
//       $(inputRef.current).on('apply.daterangepicker', function (ev, picker) {
//         const start = picker.startDate.toISOString();
//         const end = picker.endDate.toISOString();
 
//         // Update the input field
//         $(this).val(
//           picker.startDate.format('MMMM D, YYYY') + ' - ' + picker.endDate.format('MMMM D, YYYY')
//         );
 
//         // Update React state
//         setFilterData(prev => ({
//           ...prev,
//           startDate: start,
//           endDate: end,
//         }));
//       });
 
//       // Optional: clear input on cancel
//       $(inputRef.current).on('cancel.daterangepicker', function () {
//         $(this).val('');
//         setFilterData(prev => ({
//           ...prev,
//           startDate: null,
//           endDate: null,
//         }));
//       });
//     }
//   }, [filterdata]);
 
//   return (
//     <>
//       {/* <div className={`container-fluid pt-3 bdt-card-box ${filterStyles.bdt_card_box}`}>
//         <div className="card">
//           <div className={`card-body p-1 ${styles.solid_border}`}>
//             <div className="row d-flex justify-content-between">
//               <div className="col-lg-3 col-sm-3 d-flex align-items-center">
//                 <p className={` mb-0 ${filterStyles.small_bdt}`}>Last Refresh Date: {refreshDate}</p>
//               </div>
//               <div className="col-lg-7 col-sm-7 d-flex align-items-center justify-content-center">
//                 <h5 className={`mb-0 ${styles.font_bus_head}`}>Battery Digital Twin</h5>
//               </div>
//               <div className={`col-lg-2 col-sm-2 text-end ${filterStyles.filter_bus_icon_bdt}`}>
//                 <div className={`text-start mr-1 d-none rca_btn ${toHIdeShowRCA}`}>
//                   <Link to={`/dashboard_bus/rca_bus/${toSendChasisRCA}`}>
//                     <button type="button" className="btn text-white rca_btn_bus"><i className="fa fa-cogs"></i><b>&nbsp;&nbsp;RCA</b></button>
//                   </Link>
//                 </div>
//                 <div className="text-end d-inline-block">
//                   <button type="button" id="filterIcon" onClick={filterHideShow} className={`btn btn-sm  material-icons filter_bus_icon ${styles.btn_outline_primary_BDT}`}>filter_alt</button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div> */}
//       {/* <div className="container-fluid"> */}
//       <div className="card mb-3 p-3">
//         <div className="row">
//           {/* <div className={`p-2 mb-3 ${styles.bg_filter}`} id="filterSearch" style={{ display: 'none', zIndex: 1 }}> */}
 
//           {/* Wider Date Range */}
//           <div className="col-md-3">
//             <div className={`mb-1 ${styles.date_range_selection}`}>Date Range</div>
//             <div className="input-group mt-1">
//               <input
//                 type="text"
//                 ref={inputRef}
//                 className="form-control"
//                 placeholder="Select date range"
//                 value={
//                   filterdata.startDate && filterdata.endDate
//                     ? `${formatDateForDisplay(filterdata.startDate)} - ${formatDateForDisplay(filterdata.endDate)}`
//                     : ''
//                 }
//                 readOnly
//               />
//             </div>
//           </div>
 
//           {/* Other inputs */}
//           <div className="col-md-3">
//             <div className={`mb-1 ${styles.date_range_selection}`}>Select City</div>
//             <CustomSelect_Bus columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="" IND="CITY_INDEX" updateFilter={updateFilter} cty_depo="true" ></CustomSelect_Bus>
//           </div>
 
//           <div className="col-md-3">
//             <div className={`mb-1 ${styles.date_range_selection}`}>Select Up/Down Route</div>
//             <select
//               className="form-select"
//             >
//               <option value="">Select Up/Down</option>
//               <option value="up">Up</option>
//               <option value="down">Down</option>
//             </select>
//           </div>
 
//           <div className="col-md-3">
//             <div className={`mb-1 ${styles.date_range_selection}`}>Select Route</div>
//             <select
//               className="form-select"
//             >
//               <option value="">Select Route</option>
//               <option value="route1">Route 1</option>
//               <option value="route2">Route 2</option>
//             </select>
//           </div>
//           {/* <form className="g-3 mt-2 filterForm"> */}
//           {/* <div className="row">
//                 <div className="col-lg-2 col-md-6 col-sm-12">
//                   <div className="mb-3">
//                     <label htmlFor="exampleFormControlInput1" className={`${styles.form_text_label}`}>Start Date</label>
//                     <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2023-08-15T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata?.startDate} onChange={startDateChanged} />
//                   </div>
//                 </div>
//                 <div className="col-lg-2 col-md-6 col-sm-12">
//                   <div className="mb-3">
//                     <label htmlFor="exampleFormControlInput2" className={`${styles.form_text_label}`}>End Date</label>
//                     <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2023-08-15T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata?.endDate} onChange={endDateChanged} />
//                   </div>
//                 </div>
//                 <div className="col-lg-4 col-md-6 col-sm-12">
//                   <div className="mb-3">
//                     <label htmlFor="exampleFormControlInput2" className={`${styles.form_text_label}`}>Chassis No / Reg No</label>
//                     <input autoComplete="off" defaultValue={filterdata?.VIN_NUM?.join(",")} className={`${filterStyles.top_filter_bdt} filter-col`} placeholder="Chassis No / Reg No" id="vin_num" ref={inputElement} onBlur={vinnumChanged} />
//                   </div>
//                 </div>
//                 <div className="col-lg-2 col-md-6 col-sm-12 d-none">
//                   <div className="mb-3">
//                     <CustomSelect_Bus columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="CITY" IND="CITY_INDEX" updateFilter={updateFilter} cty_depo="true" ></CustomSelect_Bus>
//                   </div>
//                 </div>
//                 <div className="col-lg-2 col-md-6 col-sm-12 d-none">
//                   <div className="mb-3">
//                     <CustomSelect_Bus columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="DEPOT" IND="DEPO_INDEX" updateFilter={updateFilter} cty_depo="true" ></CustomSelect_Bus>
//                     <p className="text-danger text-center" style={{ fontSize: "12px" }}><b>{depoErrMsg}</b></p>
//                   </div>
//                 </div> */}
//           {/* this button moved here from bottom */}
//           {/* <div className={`col-lg-1 col-md-6 col-sm-12 ${filterStyles.bus_filtr_btn_bdt} ${filterStyles.filter_bus_icon_bdt}`}>
//                   <div className="mt-2">
//                     <label className="form-label_bus" />
//                     <button type="submit" className={`form-control btn btn_bus_bdt  ${styles.btn_primary_BDT} `} onClick={onsubmit}>Search</button>
//                   </div>
//                 </div>
//                 <div className={`col-lg-1 col-md-6 col-sm-12  ${filterStyles.bus_filtr_btn_bdt} ${filterStyles.filter_bus_icon_bdt} ${filterdata?.pageSelected === 1 ? "" : "d-none"}`}>
//                   <div className="mt-2">
//                     <label className={`${styles.form_text_label}`} />
//                     <Link>
//                       <button type="button" className={`form-control btn btn-secondary ${styles.btn_secondary_BDT}`} onClick={onreset}>Reset</button>
//                     </Link>
//                   </div>
//                 </div>
//                 <div className={`col-lg-1 col-md-6 col-sm-12  ${filterStyles.bus_filtr_btn_bdt} {filterStyles.filter_bus_icon_bdt} ${filterdata?.pageSelected !== 1 ? "" : "d-none"} `}>
//                   <div className="mt-2">
//                     <label className={`${styles.form_text_label}`} />
//                     <Link>
//                       <button type="button" className={`form-control btn ${styles.btn_secondary_BDT}`} onClick={() => props.onNavigateBack()}><BsFillSkipBackwardBtnFill /></button>
//                     </Link>
//                   </div>
//                 </div>
 
//               </div> */}
//           {/* <div className="row"> */}
//           {/* <div className="col-lg-2 col-md-6 col-sm-12 d-none">
//                 <div className="mb-3">
//                   <CustomSelect_Bus columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="LOB" IND="LOB_INDEX" updateFilter={updateFilter}></CustomSelect_Bus>
//                 </div>
//               </div>
//               <div className="col-lg-2 col-md-6 col-sm-12 d-none">
//                 <div className="mb-3">
//                   <CustomSelect_Bus columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="PPL" IND="PPL_INDEX" updateFilter={updateFilter}></CustomSelect_Bus>
//                 </div>
//               </div>
//               <div className="col-lg-2 col-md-6 col-sm-12 d-none">
//                 <div className="mb-3">
//                   <CustomSelect_Bus columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="PL" IND="PL_INDEX" updateFilter={updateFilter}></CustomSelect_Bus>
//                 </div>
//               </div>
//               <div className="col-lg-2 col-md-6 col-sm-12 d-none">
//                 <div className="mb-3">
//                   <CustomSelect_Bus columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="AC Type" IND="AIR_VENTILATION_INDEX" updateFilter={updateFilter}></CustomSelect_Bus>
//                 </div>
//               </div> */}
//           {/* <div className={`col-lg-1 col-md-6 col-sm-12 bus_filtr_btn_bdt ${filterStyles.filter_bus_icon_bdt}`}>
//                 <div className="mt-2">
//                   <label className="form-label_bus" />
//                   <button type="submit" className="form-control btn btn_bus_bdt btn-primary" onClick={onsubmit}>Search</button>
//                 </div>
//               </div>
//               <div className={`col-lg-1 col-md-6 col-sm-12 bus_filtr_btn_bdt ${filterStyles.filter_bus_icon_bdt}`}>
//                 <div className="mt-2">
//                   <label className="form-label_bus" />
//                   <Link>
//                     <button type="button" className="form-control btn btn-secondary" onClick={onreset}>Reset</button>
//                   </Link>
//                 </div>
//               </div> */}
//           {/* </div> */}
//           {/* </form> */}
//           {/* </div> */}
//         </div>
//       </div>
//       {/* </div> */}
//     </>
//   )
// }